module.exports = __webpack_public_path__ + "static/media/collection-hatching.14cbc727.mp3";